import { Capacitor } from "@capacitor/core";

export function isNativeiOS() {
  return Capacitor.getPlatform() === "ios";
}

export function isNativeAndroid() {
  return Capacitor.getPlatform() === "android";
}

export function isNative() {
  return Capacitor.isNativePlatform();
}

export function isWeb() {
  return Capacitor.getPlatform() === "web";
}
